import Axios from "@/global/AxiosCall";
import {url} from '@/configs/apiUrl'

/**
 * default API response structure
 * {
 *     code: <integer>,
 *     message: <string>,
 *     data: <object>
 * }
 */
export default class SsoAPI {

    /**
     * api call authorize to get code from sso server
     *payload = {
     *     redirect_uri: <string>
     *}
     * @param payload
     * @returns {Promise<unknown>}
     */
    static Authorize(payload) {
        return new Promise(((resolve, reject) => {
            var urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
            if (urlregex.test(payload.redirect_uri)) {
                Axios.Get(url.svd.sso.authorize).then((result) => {
                    if (result.code === 200)
                        resolve(result)
                }, (err) => {
                    console.log(err.message)
                    reject(err)
                })
            } else {
                let err = {
                    code: 404,
                    message: 'domain invalid format'
                }
                reject(err)
            }
        }))
    }
}